import * as React from "react";
import { Link } from "react-router-dom";

type Props = {
  src: string;
  tag?: boolean;
  class?: string;
  style?: any;
  id?: string;
  link?: string;
};
export default class BOImage extends React.Component<Props, any> {
  static defaultProps = {
    src: "",
    tag: true,
    class: "",
    style: {},
    id: "",
    link: ""
  };

  constructor(props: any) {
    super(props);

    this.Create = this.Create.bind(this);
  }
  Create(): any {
    const { tag, src, id, link } = this.props;
    var Obj = {};
    const Props = {
      style: {}
    };

    if (this.props.class) {
      Props["className"] = this.props.class;
    }
    if (id) {
      Props["id"] = id;
    }

    var element = "";
    if (tag) {
      element = "img";
      Props["src"] = src;
    } else {
      element = "div";
      Props["style"]["backgroundImage"] = `url(${src})`;
    }

    Obj = React.createElement(element as any, Props, null);

    if (link !== "") {
      Obj = React.createElement(
        Link,
        {
          to: link,
          style: {
            textDecoration: "none"
          }
        },
        Obj
      );
    }

    return Obj;
  }
  render(): JSX.Element {
    return this.Create();
  }
}
